import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgForm, FormsModule } from '@angular/forms';
import { NgIf, NgTemplateOutlet, NgFor, NgClass, LowerCasePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { HtmlSanitizerService, SafeHtmlPipe } from '@laasy/common-layout';

@Component({
  selector: 'app-input',
  templateUrl: './validations.component.html',
  styleUrls: ['./validations.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputComponent,
      multi: true
    }
  ],
  standalone: true,
  imports: [NgIf, FormsModule, NgTemplateOutlet, NgFor, NgClass, LowerCasePipe, SafeHtmlPipe]
})
export class InputComponent implements ControlValueAccessor {
  @Input() name!: string;
  @Input() formGroup!: NgForm;
  @Input() label!: string;
  @Input() placeholder: string = '';
  @Input() type!: string;
  @Input() isEditable!: boolean;
  @Input() readOnly = false;
  @Input() options: any
  @Input() defaultOption: string | undefined;
  @ViewChild('inputLabel') inputLabel!: ElementRef;

  constructor(
    private renderer: Renderer2,
    private htmlSanitizer: HtmlSanitizerService
  ) { }

  showPassword: boolean = false;

  val = '';
  get control(): FormControl {
    return this.formGroup.controls[this.name] as FormControl;
  }

  /**
   * Getter for safely sanitized label content
   * This prevents XSS attacks by escaping HTML in labels
   */
  get safeLabel(): string {
    return this.htmlSanitizer.sanitizeLabel(this.label);
  }

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): any {
    return this.val;
  }

  set value(val: string) {
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: any): void {
    this.value = value;
    if (!!value && value?.length) {
      this.isEditable = false;
    } else {
      this.formGroup.control.markAsPristine();
      this.formGroup.control.markAsUntouched();
      this.isEditable = true;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(onTouched: Function): void {
    this.onTouch = onTouched;
  }

  handlePasswordDisplay(): void {
    this.showPassword = !this.showPassword;
  }

  hideLabel() {
    this.renderer.setStyle(this.inputLabel.nativeElement, 'display', 'none');
  }

  get customError(): string | null {
    const error = this.control?.errors?.['custom'] || null;
    return error;
  }
}
